import React from "react";
import "../CSS/AboutSection.css"; 

const AboutSection = () => {
  return (
    <section id="about" className="tk-about">
        <div className="tk-about-left">
          <h2>Revolutionizing TB Care<br/>with Smart Technology</h2>
          
          <p className="tk-about-text">
            TibiSmart is an intelligent application powered by AI and GIS that
            supports healthcare workers in patient screening, monitoring the
            therapy progress, predicting medication dropout risks, mapping
            high-risk transmission areas, and enabling direct communication with
            patients to ensure successful TB treatment.
          </p>
          
          <button className="tk-readmore">Read More</button>
        </div>

        <div className="tk-about-right">
          <img
            src={process.env.PUBLIC_URL + "/assets/gambar4.png"}
            alt="doctor looking at xray"
            className="tk-about-image"
          />
        </div>
      </section>
  );
};

export default AboutSection;
